import type { AxiosRequestConfig } from "axios";
import qs from "qs";
import { axiosInstance } from "../../axios-instance";
import { qsOptions } from "../qsOptions";
import type { R } from "../types";
import type {
  IDeleteAdminRequest,
  IDeleteAdminResponse,
  IGetAdminProfileByUserIdRequest,
  IGetAdminProfileByUserIdResponse,
  IGetAdminsRequest,
  IGetAdminsResponse,
} from "./types";

export class AdminsService {
  async getAll(
    p: IGetAdminsRequest,
    c?: AxiosRequestConfig,
  ): R<IGetAdminsResponse> {
    const params = qs.stringify(p, qsOptions);
    return axiosInstance.get(`/api/admin/all?${params}`, c);
  }

  async getProfileByUserId(
    p: IGetAdminProfileByUserIdRequest,
    c?: AxiosRequestConfig,
  ): R<IGetAdminProfileByUserIdResponse> {
    try {
      return axiosInstance.get(`/api/admin/user/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async deleteAdmin(
    p: IDeleteAdminRequest,
    c?: AxiosRequestConfig,
  ): R<IDeleteAdminResponse> {
    try {
      return axiosInstance.delete(`/api/admin/${p.userId}`, c);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
